"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MultiFetch = void 0;
class MultiFetch {
    constructor(options) {
        this.options = options;
        this.items = [];
    }
    find(payload) {
        const index = this.items.findIndex(item => {
            return this.options.isEqual(item, payload);
        });
        const item = index > -1 ? this.items[index] : undefined;
        return { item, index };
    }
    findLatest(payload) {
        let latest;
        for (const item of this.items) {
            if (!this.options.isEqual(item, payload)) {
                continue;
            }
            if (!latest || latest.requestDate <= item.requestDate) {
                latest = item;
            }
        }
        return latest;
    }
    filter(payload) {
        return this.items.filter(item => this.options.isEqual(item, payload));
    }
    remove(payload) {
        const result = this.find(payload);
        if (result.index > -1) {
            this.items.splice(result.index, 1);
        }
        return result;
    }
    clear() {
        return this.items.splice(0, this.items.length);
    }
    // handle promise update
    resolve(item) {
        return __awaiter(this, void 0, void 0, function* () {
            if (item.isResolved) {
                return item;
            }
            try {
                const { data, error } = (yield item.promise) || {};
                item.data = data;
                item.error = error;
            }
            catch (error) {
                // ignore when request is aborted
                if (!(error instanceof DOMException && error.name === 'AbortError')) {
                    item.error = {
                        statusCode: 500,
                        error: 'Fetch Error',
                        message: 'An error occurred while loading the results.'
                    };
                }
            }
            finally {
                item.isResolved = true;
                // clean up to free up memory
                delete item.promise;
                delete item.abort;
            }
            return item;
        });
    }
    save(existing, dto) {
        let item = Object.assign(Object.assign({}, dto), { isResolved: false, requestDate: new Date() });
        if (existing) {
            // use the same object reference when updating
            item = Object.assign(existing, item);
            delete item.error;
        }
        else {
            this.items.push(item);
        }
        return item;
    }
    /**
     * Fetch data if it does not exist yet or use cached data.
     * @param payload The payload.
     * @param refetch Set to `true` to refetch data instead of using cached data.
     */
    fetch(payload, refetch = false) {
        return __awaiter(this, void 0, void 0, function* () {
            // check for existing item
            const existing = this.find(payload).item;
            if (!existing) {
                // do nothing and only satisfy non undefined `item` type
            }
            else if (refetch && !existing.isResolved) {
                // skip if currently fetching
                return existing;
            }
            else if (!refetch) {
                if (!existing.isResolved && existing.promise) {
                    // wait for promise to resolve if it exists so that similar
                    // multiple calls to `this.fetch()` will reuse the same data
                    yield existing.promise;
                }
                return existing;
            }
            const fetch = this.options.fetch(payload);
            if (!fetch) {
                return;
            }
            const { request, result } = fetch;
            const savedItem = this.save(existing, {
                payload,
                promise: result,
                abort: () => request.abort()
            });
            yield this.resolve(savedItem);
            return savedItem;
        });
    }
}
exports.MultiFetch = MultiFetch;
//# sourceMappingURL=MultiFetch.js.map